const initialState = [
  {
    QRData: [],
  },
];

const loginQrReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_QR":
      return {
        ...state,
        QRData: action.payload,
      };
    default:
      return state;
  }
};

export default loginQrReducer;
